import { TagsSettings, TagsOptions } from 'src/types/Main'
import FilteredColorTag from './filteredColorTag'
import { translateString } from '../../utils/translateString'
import { useCallback } from 'react'

interface Props {
  appliedTags: Record<string, string[]>;
  tags: TagsSettings[];
  handlesApply: (
    paramsTags: Record<string, string[]> | null,
    paramsProperties: Record<string, string[]> | null,
    paramsSort: string | null,
    paramsMinPrice: number | null,
    paramsMaxPrice: number | null
  ) => void;
}

const FilteredTags = (props: Props) => {
  const { appliedTags, tags, handlesApply } = props

  const tagsStyles = tags.reduce((accumulator: Record<string, string>, tag) => {
    accumulator[tag.type] = tag.style
    return accumulator
  }, {})

  const tagsOptions = tags.reduce((accumulator: Record<string, TagsOptions[]>, tag) => {
    accumulator[tag.type] = tag.options
    return accumulator
  }, {})

  const removeTag = useCallback((tagToRemove: string, tagType: string) => {
    const newAppliedTags = { ...appliedTags }

    if (newAppliedTags[tagType]) {
      newAppliedTags[tagType] = newAppliedTags[tagType].filter((tag) => tag !== tagToRemove)

      if (newAppliedTags[tagType].length === 0) {
        delete newAppliedTags[tagType]
      }
    }

    handlesApply(newAppliedTags, null, null, null, null)
  }, [appliedTags, handlesApply])

  return (
    <>
      {Object.entries(appliedTags).map(([tagType, values]) => (
        <div key={tagType} className="filtered-tags filtered-type">
          {tagsStyles[`${decodeURIComponent(tagType)}`] === 'colors'
            ? <FilteredColorTag
                tagType={tagType}
                values={values}
                tagsOptions={tagsOptions}
                removeTag={removeTag}
              />
            : (
                values.map((tag) => {
                  const matchingOption = tagsOptions[`${decodeURIComponent(tagType)}`]?.find((option) => option.name === tag)
                  return matchingOption && (
                    <div key={tag} className="filtered-item">
                      <div>{`${translateString(matchingOption.title)}`}</div>
                      <button aria-label={`Limpar filtro de categoria: ${translateString(matchingOption.title)}`} className="filtered-items-button-clear" onClick={() => removeTag(tag, tagType)}></button>
                    </div>
                  )
                })
              )}
        </div>
      ))}
  </>
  )
}

export default FilteredTags
